import React from 'react';
import { Card, Empty, Typography } from 'antd';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { brand } from '@/theme/tokens';

export interface ChartSeries {
  key: string;
  label: string;
  color?: string;
}

interface Props {
  title: string;
  data: Array<Record<string, string | number>>;
  xKey: string;
  series: ChartSeries[];
  height?: number;
}

const DEFAULT_COLORS = [brand.primary, brand.commerce, brand.gold, brand.win];

export function LineChartCard({ title, data, xKey, series, height = 260 }: Props): React.ReactElement {
  return (
    <Card title={title} style={{ border: `1px solid ${brand.line}`, borderRadius: 4 }}>
      {data.length === 0 ? (
        <Empty description="Nessun dato nel periodo selezionato" />
      ) : (
        <ResponsiveContainer width="100%" height={height}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke={brand.line} />
            <XAxis dataKey={xKey} tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip />
            <Legend />
            {series.map((s, i) => (
              <Line
                key={s.key}
                type="monotone"
                dataKey={s.key}
                name={s.label}
                stroke={s.color ?? DEFAULT_COLORS[i % DEFAULT_COLORS.length]}
                strokeWidth={2}
                dot={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      )}
      {data.length > 0 && (
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>
          {data.length} giorni nel periodo
        </Typography.Text>
      )}
    </Card>
  );
}
